export default "__VITE_ASSET__nZRjh$SJ__"